import { Component, OnInit, TemplateRef } from '@angular/core';
import { ItemStockReportViewModel } from 'src/app/viewmodels/g-item/ItemStockReportViewModel';
import { JqHelper } from 'src/app/common/jq-helper';
import { UnitOfWorkService } from 'src/app/services/api/uow/unit-of-work.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { NgxSpinnerService } from 'ngx-spinner';
import { GetItemStockReport, StockReportTotalViewModel } from 'src/app/viewmodels/g-item/StockReportTotalViewModel';
import { ExportExcel } from 'src/app/viewmodels/ExportExcel';
import Swal from 'sweetalert2';
import { LocalStorageService } from 'src/app/services/common/local-storage.service';
import { WareHouseModel } from 'src/app/viewmodels/ItemViewModel';

@Component({
  selector: 'app-itemstockreport',
  templateUrl: './itemstockreport.component.html',
  styleUrls: ['./itemstockreport.component.scss']
})
export class ItemstockreportComponent implements OnInit {
  modalRefLv1: BsModalRef;
  modalRefLv2: BsModalRef;
  public stockTotal: GetItemStockReport = new GetItemStockReport();
  public vmListItems: any = [];
  p: number = 1;
  public component_Title = 'Item Stock Report';
  public exportFormat: string = 'csv';
  startDate: any = null;
  endDate: any = null;
  public client: any;
  public wareHouses: Array<any> = [];
  public user: any;
  public wareHouseVm = new WareHouseModel();
  constructor(
    private _jq: JqHelper,
    private _uow: UnitOfWorkService,
    private _modalService: BsModalService,
    private spinner: NgxSpinnerService,
    private _localStorageService: LocalStorageService
  ) { }

  ngOnInit() {
    this.client = this._localStorageService.get("com");
    this.user = this._localStorageService.get("ussr");
    this.getReport(0);
    //this.getWarehouse();
  }
  public getReport(id){
    this.spinner.show();
    this._uow.gReportingService.GetItemStockReportAsync(id).subscribe((res: any) => {
      this.vmListItems = res.reult;
      this.stockTotal = res.result;


      this.spinner.hide();
    }, (err) => {
      console.log(err);
      // this._jq.showSpinner();
      this.spinner.hide();
    });
  }

  openModal(template: TemplateRef<any>) {
    this.modalRefLv1 = this._uow.modalServiceEx.show(template);
    this.modalRefLv1.setClass('modal-lg');
  }
  openExportModel(template: TemplateRef<any>) {
    this.openModal(template);
  }

  exportToExcel() {
    debugger;
    this.spinner.show();
    // var obj = new ExportExcel();
    // obj = {

    //   StartDate: this.startDate,
    //   EndDate: this.endDate,
    //   Format: this.exportFormat
    // }
    this._uow.gReportingService.GetItemStockReportExportAsync(this.startDate, this.endDate).subscribe((res: any) => {
      debugger;
      this.openLinkInNewTab(res.file);
      this.spinner.hide();
      this.modalRefLv1.hide();
    },
      (error) => {
        this._uow.logger.log(error);
        this.spinner.hide();
        Swal.fire(
          'Failure!',
          'Network Issue!',
          'error'
        )
      });
  }

  openLinkInNewTab(url) {
    window.open(url, '_blank');
  }

  getWarehouse() {
    return new Promise((resolve, reject) => {
      this._uow.gSettingService.GetUserWarehouseAsync(this.user.Id).subscribe((res: any) => {
        debugger
        console.log("warehouses", res);
        this.wareHouses = res.result;
        resolve(res);
      });
    });
  }

  onSelectWareHouse() {
    console.log(this.wareHouseVm.wareHouse);
    this.getReport(this.wareHouseVm.wareHouse.id);
  }


  // exportToExcel() {
  //   debugger;
  //   this.spinner.show();
  //   var obj = new ExportExcel();
  //   obj = {
  //     StartDate: this.startDate,
  //     EndDate: this.endDate,
  //     Format: this.exportFormat
  //   }
  //   this._uow.itemService.ExportStockReport(obj).subscribe((res: any) => {
  //     debugger;

  //     const blob = new Blob([res], { type: res.type });
  //     const url = window.URL.createObjectURL(blob);
  //     const a = document.createElement('a');
  //     a.href = url;
  //     a.download = `ItemStockReportData_${new Date().toISOString().split('T')[0]}.${this.exportFormat.toLowerCase()}`;
  //     document.body.appendChild(a);
  //     a.click();
  //     window.URL.revokeObjectURL(url);
  //     document.body.removeChild(a);

  //     this.spinner.hide();
  //     this.modalRefLv1.hide();
  //   },
  //     (error) => {
  //       this._uow.logger.log(error);
  //       this.spinner.hide();
  //       Swal.fire(
  //         'Failure!',
  //         'Network Issue!',
  //         'error'
  //       )
  //     });
  // }

}
